"use client"

import { WalletMinimal } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WalletMinimalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WalletMinimalIcon = component(Icon)({ as: WalletMinimal })
